(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-splide-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    let editorSelectedSlideId = null;

    const parseOptions = (element) => {
      try {
        const options = JSON.parse(element.dataset.options || '{}');

        if (window.Shopify && window.Shopify.designMode) {
          options.autoplay = false;
        }

        return options;
      } catch (error) {
        return {};
      }
    };

    const destroy = (root) => {
      root.querySelectorAll('[data-custom-splide]').forEach((element) => {
        const instance = instances.get(element);

        if (instance) {
          instance.destroy(true);
          instances.delete(element);
        }
      });
    };

    const syncSelectedSlide = (root = document, slideId = editorSelectedSlideId) => {
      if (!slideId) return;

      root.querySelectorAll('[data-custom-splide]').forEach((slider) => {
        const instance = instances.get(slider);

        if (!instance) return;

        const slides = Array.from(
          slider.querySelectorAll('.splide__list > [data-custom-splide-slide-id]:not(.splide__slide--clone)')
        );
        const index = slides.findIndex((slide) => slide.dataset.customSplideSlideId === slideId);

        if (index < 0) return;

        instance.go(index);

        if (instance.Components && instance.Components.Autoplay) {
          instance.Components.Autoplay.pause();
        }
      });
    };

    const syncSelectedSlideAfterRender = (root = document, slideId = editorSelectedSlideId) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => syncSelectedSlide(root, slideId));
      });
    };

    const init = (root = document) => {
      const sliders = root.querySelectorAll('[data-custom-splide]');

      if (sliders.length === 0) return;

      if (!window.Splide) {
        window.addEventListener('load', () => init(root), { once: true });
        return;
      }

      sliders.forEach((element) => {
        const currentInstance = instances.get(element);

        if (currentInstance) {
          currentInstance.destroy(true);
          instances.delete(element);
        }

        const instance = new window.Splide(element, parseOptions(element));
        instance.mount();
        instances.set(element, instance);
      });

      syncSelectedSlideAfterRender(root);
    };

    const sectionRootFromEvent = (event) => {
      if (!event.target) return document;
      return event.target.querySelector('[data-custom-splide-section]') ? event.target : document;
    };

    const editorBlockId = (element) => {
      if (!element || !element.dataset || !element.dataset.shopifyEditorBlock) return null;

      try {
        return JSON.parse(element.dataset.shopifyEditorBlock).id;
      } catch (error) {
        return null;
      }
    };

    const selectedEditorBlock = (event, root) => {
      const blockId = event.detail && event.detail.blockId;
      const closestBlock =
        event.target && event.target.closest ? event.target.closest('[data-shopify-editor-block]') : null;

      if (closestBlock && (!blockId || editorBlockId(closestBlock) === blockId)) {
        return closestBlock;
      }

      if (!blockId) return closestBlock;

      return Array.from(root.querySelectorAll('[data-shopify-editor-block]')).find(
        (element) => editorBlockId(element) === blockId
      );
    };

    const selectedSlideId = (event, root) => {
      const blockId = event.detail && event.detail.blockId;

      if (blockId && root.querySelector(`[data-custom-splide-slide-id="${blockId}"]`)) {
        return blockId;
      }

      const selectedBlock = selectedEditorBlock(event, root);
      const selectedSlide =
        selectedBlock && selectedBlock.closest ? selectedBlock.closest('[data-custom-splide-slide-id]') : null;

      return selectedSlide ? selectedSlide.dataset.customSplideSlideId : null;
    };

    const goToSelectedSlide = (event) => {
      const sectionRoot = sectionRootFromEvent(event);
      const slideId = selectedSlideId(event, sectionRoot);

      if (!slideId) return;

      editorSelectedSlideId = slideId;
      init(sectionRoot);
      syncSelectedSlideAfterRender(sectionRoot, slideId);
    };

    document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (event) => init(sectionRootFromEvent(event)));
    document.addEventListener('shopify:section:unload', (event) => destroy(sectionRootFromEvent(event)));
    document.addEventListener('shopify:block:select', goToSelectedSlide);
    document.addEventListener('shopify:block:deselect', (event) => syncSelectedSlideAfterRender(sectionRootFromEvent(event)));

    window.CustomSplideSlideshow = { init, destroy };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["table-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
